// import React from "react";
// import { userHistory } from "react-router-dom";
import { authenticationService } from "./authentication";

export function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if ([401, 403].indexOf(response.status) !== -1) {
        // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
        // history.push('/')
        authenticationService.logout();
        window.location.replace('/')
        window.location.reload(true);
      }
      const error = (data && data.errors ? data.errors.message : data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}
